import { handleActions } from 'redux-actions';
import * as uiActions from '../actions/ui';

let UIState = {
    filtersCount: null
};

export const ui = handleActions(
    {
        //Счетчик фильтров
        [uiActions.setFiltersCount]: (_state, action) => {
            let { payload } = action;
            return { filtersCount: payload.length };
        }
    },
    UIState
);
